export default __webpack_public_path__ + "static/media/goiCuocHeadMobifone.cf6404a4.svg";